<template>
<v-app-bar id="home-app-bar2" v-if="!isLoading" style="margin-top:44px" app color="#fff" elevation="1" height="80">
     <div >
          <v-btn width="70" height="60" @click="goToHome" text>
               <v-img v-if="settings[0]" width="60" :src=" 'logo/' + settings[0].logo | URL"></v-img>
               <v-img v-else width="60" :src=" require('@/assets/logo.png')"></v-img>
          </v-btn>
     </div>
     <div width="500" class="mx-10 hidden-sm-and-down">
          <v-row>
               <v-col cols="2">
                    <v-icon :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-phone-classic</v-icon>
               </v-col>
               <v-col cols="10">
                    <h3 class="textBetwin  hidden-md-and-down">{{ $t('casUrgent') }}</h3>
                    <h3 class="textBetwin">{{ settings[0] ? settings[0].telephone.replace(/ /g, "") : '-- -- -- -- -- --' }}</h3>
               </v-col>
          </v-row>

     </div>
     <div class="mx-10  hidden-sm-and-down hidden-md-and-down">
          <v-row>
               <v-col cols="2">
                    <v-icon :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-map-marker</v-icon>
               </v-col>
               <v-col cols="10">
                    <h3 class="textBetwin">{{ getWilaya}}</h3>
                    <h3 class="textBetwin">{{getCommune }}</h3>
               </v-col>
          </v-row>
     </div>
     <div class="mx-10  ">
          <v-row @click="goToAdminPart" class="clickAccount hand">
               <v-col cols="3">
                    <v-icon :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-account</v-icon>
               </v-col>
               <v-col cols="9" class="hidden-sm-and-down">
                    <h3 class="textBetwin colorHover">{{ $t('login') }}</h3>
               </v-col>
          </v-row>
     </div>
     <div class="mx-10 hidden-sm-and-down">
          <v-row>
               <v-col cols="12">
                    <v-btn icon>
                         <a :href="settings[0] ? settings[0].facebook : 'https://www.facebook.com/'" style="text-decoration:none" target="blank"><v-icon size="30" :color="(settings[0] ? settings[0].color : '#2F839D')"> mdi-facebook</v-icon></a>
                    </v-btn>
                    <v-btn icon>
                         <a :href="settings[0] ? settings[0].twitter : 'https://twitter.com/'" style="text-decoration:none" target="blank"><v-icon size="30" class="mx-6" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-twitter</v-icon></a>
                    </v-btn>
               </v-col>
          </v-row>
     </div>
</v-app-bar>

 <v-skeleton-loader v-else ref="skeleton" type="table-thead"></v-skeleton-loader>
</template>

<script>
export default {
 
     methods: {
          goToAdminPart() {
               this.$router.push('/admin')
          },
          goToHome() {
               Fire.$emit('goToSite', true)
          },
          handleScroll(event) {
               let doc =  document.getElementById("home-app-bar2")
               if ((event.path[1].pageYOffset > 70) && doc) {
                   doc.style.top = "-125px"
                   doc.style.transition = "0.6s"
               } else {
                   doc.style.top = "0px"
                   doc.style.transition = "0.6s"
               }
          }
     },
     computed: {
          
     },
     created() {
          window.addEventListener('scroll', this.handleScroll);
     },
     destroyed() {
          window.removeEventListener('scroll', this.handleScroll);
     },
}
</script>

<style lang="scss" scoped>
.textBetwin {
     color: #777;
     font-style: italic;
}

.clickAccount:hover {
     border: 1px solid #2F839D;
     background: #eee;

     .colorHover {
          color: #2F839D;
     }
}
 
</style> 
